<template>
  <div class="life_costs-pages-prestore-list content-container" id="life_costs-pages-prestore-list">
    <div class="container-scroll">
      <!--导航部分-->
      <section class="layout-pad-full layout-margin-bottom back-white">
        <a-breadcrumb>
          <a-breadcrumb-item>首页</a-breadcrumb-item>
          <a-breadcrumb-item>生活中心</a-breadcrumb-item>
          <a-breadcrumb-item>开票历史</a-breadcrumb-item>
        </a-breadcrumb>
      </section>
      <!--导航部分 end-->
      <!--search部分-->
      <section class="layout-pad-full layout-pad-top-nil layout-margin-bottom back-white">
          <h1 class="holder-title">搜索条件</h1>
          <a-form class="cabinvue-search-form">
              <a-row :gutter="24">
                  <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>合同号：</span>
                          </div>
                          <div class="item-control">
                              <a-input v-model="condition.custName" placeholder="请输入合同号" />
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>开票日期：</span>
                          </div>
                          <div class="item-control">
                              <a-range-picker
                                style="width:100%;"
                                v-model="pageData.invoiceDate"
                                @change="invoiceDateChange"
                                format="YYYY-MM-DD"
                              />
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>开票类型：</span>
                          </div>
                          <div class="item-control">
                              <a-select v-model="condition.invoiceType" placeholder="请选择开票类型">
                                <a-select-option v-for="item in pageData.invoiceTypeList" :key="item.code" :value="item.code">{{item.value}}</a-select-option>
                              </a-select>
                          </div>
                      </div>
                  </a-col>
                  <a-col :xl="6" :lg="8" :md="8" :sm="12" :xs="24">
                      <div class="search-form-item">
                          <div class="item-label">
                              <span>开票状态：</span>
                          </div>
                          <div class="item-control">
                              <a-select v-model="condition.invoiceStatus" placeholder="请选择开票状态">
                                <a-select-option v-for="item in pageData.invoiceStatusList" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
                              </a-select>
                          </div>
                      </div>
                  </a-col>
              </a-row>
              <hr />
              <div class="form-option-area">
                  <a-button icon="search" class="space-margin-right" type="primary" :loading="tableObj.tableLoading"
                      @click.stop="search">查询</a-button>
                  <a-button icon="reload" class="space-margin-right btn-outline" @click.stop="resetEvt">重置</a-button>
              </div>
          </a-form>
      </section>
      <!--search部分 end-->
      <!--表格部分-->
      <section class="layout-table layout-pad-full layout-margin-bottom back-white">
        <a-table 
          size="middle" 
          class="J_compensation_list_table" 
          :columns="tableObj.columns"
          :data-source="tableObj.list" 
          :scroll="tableObj.scroll"
          :pagination="false"
          :loading="tableObj.tableLoding"
          >
          <template slot="action" slot-scope="text, record">
            <router-link :to="`/invoice/history/detail?invoiceOrderNo=${record.invoiceOrderNo}`">详情</router-link>
            <a-divider type="vertical" v-if="record.invoiceType === '1' && record.invoiceStatus === '3'" />
            <a href="javascript:;" v-if="record.invoiceType === '1' && record.invoiceStatus === '3'" @click="invoiceUrlOpen(record)">下载发票</a>
            <a-divider type="vertical" v-if="record.redChancelFlag === '1' && record.invoiceStatus === '3'" />
            <a href="javascript:;" v-if="record.redChancelFlag === '1' && record.invoiceStatus === '3'" @click="redApply(record)">冲红审批</a>
            <a-divider type="vertical" v-if="record.approvalStatus === '1'" />
            <a href="javascript:;" v-if="record.approvalStatus === '1'" @click="invoice(record)">开票申请</a>
          </template>
        </a-table>
        <div class="clearfix">
          <a-pagination 
            style="margin-top:8px;float: right;" 
            show-size-changer 
            @change="pagination.change"
            @showSizeChange="pagination.showSizeChange"
            :default-current="pagination.defaultCurrent"
            v-model="pagination.current"
            :defaultPageSize = "pagination.defaultPageSize"
            :total="pagination.total"
            :show-quick-jumper="pagination.showQuickJumper"
            :page-size-options="pagination.pageSizeOptions"
            :show-total='pagination.showTotal'>
          </a-pagination>
        </div>
      </section>
      <!--表格部分 end-->

      <a-modal 
        v-model="modal.visible"
        width="50%"
        :footer="null"
        @cancel="modalCancel">
        <a-result
          status="success"
          :title="modal.result"
          :sub-title="`尊敬的客户您好：您于${modal.currentDate}开具电子发票，发票信息如下。`"
        >
          <template>
            <a-table 
              size="middle" 
              :columns="modal.columns"
              :data-source="modal.list" 
              :pagination="false">
              <template slot="action" slot-scope="text, record">
                <a href="javascript:;" @click="invoiceUrlOpen(record)" v-if="record.invoiceUrl">下载发票</a>
              </template>
            </a-table>
          </template>
        </a-result>
      </a-modal>

    </div>
  </div>
</template>

<script>
import moment from 'moment';
import NP from 'number-precision'
import ajax from '../../lib/axios/ajax'
import { POST_PAYBILL_QUERYPAYSTATEENUM, INVOICE_QUERYINVOHISLIST, INVOICE_REDAPPLY, INVOICE_INVOICE } from '../../lib/axios/apilist'

export default {
//这里必须 使用一个方法返回给data
  data: function () {
    let pagination = {
      pageSize: 10,
      current: 1,
      defaultCurrent: 1,
      defaultPageSize: 10,
      total: 0,
      showQuickJumper: true,
      showTotal: total => `共${total}条数据`,
      showSizeChanger: true,
      pageSizeOptions: ['10', '30', '50', '100'],
      showSizeChange: (current, pageSize) => {
        this.pagination.pageSize = pageSize;
        this.pagination.current = current;
        this.$options.methods.search.bind(this)();
      },
      change: (page, pageSize) => {
        this.pagination.current = page;
        this.pagination.pageSize = pageSize;
        this.$options.methods.search.bind(this)(false);
      }
    };

    let condition = {
      contrantId: undefined,
      startDate: undefined,
      endDate: undefined,
    }
    let tableObj = {
      tableLoading: false,
      selectedRowKeys: [],
      list: [],
      scroll: {
        x: 2600,
        y: '100%'
      },
      columns: [
        { title: '订单号', dataIndex: 'invoiceOrderNo', width: 250 }, 
        { title: '客户编号', dataIndex: 'custId' }, 
        { title: '客户名称', dataIndex: 'custName' }, 
        { title: '合同号', dataIndex: 'contrantId' }, 
        { title: '门店编号', dataIndex: 'mchNo' }, 
        { title: '门店名称', dataIndex: 'mchName' }, 
        { title: '开票金额', dataIndex: 'invoiceAmount' }, 
        { title: '发票种类', dataIndex: 'invoiceTypeName' }, 
        { title: '发票项目', dataIndex: 'invoiceItem' }, 
        { title: '开票日期', dataIndex: 'invoiceDate' }, 
        { title: '客户税号', dataIndex: 'custTaxNo' }, 
        { title: '客户地址', dataIndex: 'custAdress' }, 
        { title: '客户手机号', dataIndex: 'custPhone' }, 
        { title: '客户银行账户', dataIndex: 'merBankNo' }, 
        { title: '客户银行开户行', dataIndex: 'merOpenBank' }, 
        { title: '发票代码', dataIndex: 'invoiceCode' }, 
        { title: '发票号码', dataIndex: 'invoiceNo' }, 
        { title: '发票状态', dataIndex: 'invoiceStatusName' }, 
        { title: '审批状态', dataIndex: 'approvalStatusName' }, 
        { title: '操作', dataIndex: 'action', fixed: 'right', scopedSlots: { customRender: 'action' }, }
      ]
    }
    let pageData = {
      invoiceDate: [],
      invoiceTypeList: [],
      invoiceStatusList: []
    }
    let modal = {
      visible: false,
      result: '开具成功',
      currentDate: moment().format('YYYY年MM月DD日'),
      columns: [
        { dataIndex: 'invoiceOrderNo', title: '发票订单号', },
        { dataIndex: 'invoiceDate', title: '开票日期', },
        { dataIndex: 'invoiceCode', title: '发票代码', },
        { dataIndex: 'invoiceNo', title: '发票号码', },
        { dataIndex: 'sellerName', title: '销方公司名称', },
        { dataIndex: 'custCompanyName', title: '购方公司名称', },
        { dataIndex: 'invoiceAmount', title: '发票金额', },
        { dataIndex: 'message', title: '开票结果描述', },
        { dataIndex: 'action', title: '发票下载地址', width: 100, fixed: 'right', scopedSlots: { customRender: 'action' }, },
      ],
      list: []
    }
    return {
      modal,
      pageData,
      pagination,
      condition,
      tableObj,
    }
  },
  beforeCreate () {
  },
  mounted() {
    this.queryPayStateEnum()
    this.$nextTick(function () {
      this.$options.methods.search.bind(this)(false);
      this.$options.methods.search.bind(this)(false);
    });
  },
  beforeDestroy: function () {
    
  },
  destroyed: function () {
    
  },
  watch: {
  },
  computed: {
    hasSelected() {
      return this.tableObj.selectedRowKeys.length > 0;
    },
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    invoiceDateChange(date, dateString) {
      if (dateString) {
        this.condition.startDate = dateString[0];
        this.condition.endDate = dateString[1];
      } else {
        this.pageData.invoiceDate = [];
      }
    },
    queryPayStateEnum(){
      let url = POST_PAYBILL_QUERYPAYSTATEENUM;
      let successFunc = (res) => {
        if (res.code === "0000") {
          this.pageData.invoiceTypeList = res.data.invoiceTypeList
          this.pageData.invoiceStatusList = res.data.invoiceStatusList
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.$error({
          title: '提示',
          content: res.result,
        });
      };
      let requestParam = {
      }
      ajax.fetch(url, requestParam, successFunc, errorFunc)
    },
    search(startFlag = true, param = {}, tempPagination = this.pagination) {
      let searchParam = {
        ...this.condition
      }
      // 开启加载效果
      this.tableObj.tableLoading = true;
      //浅复制
      let requestParam = Object.assign({}, searchParam, param);
      let currentPageNo = tempPagination.current;
      let currentPageSize = tempPagination.pageSize;
      if (startFlag) {
        requestParam.currentPage = 1;
      } else {
        requestParam.currentPage = currentPageNo;
      }
      requestParam.pageSize = currentPageSize;

      // 清空table数据
      this.tableObj.list = [];

      let that = this;
      let successFunc = (res) => {
        // 关闭加载效果
        this.tableObj.tableLoading = false;
        if (res.code === "0000") {
          this.pagination.current = res.data.currentPage;
          this.pagination.defaultCurrent = res.data.currentPage;
          this.pagination.pageSize = res.data.pageSize;
          this.pagination.total = res.data.totalCount;
          this.tableObj.list = res.data.result
          //调整TABLE样式
          that.$nextTick(function () {
            //根据表格实际宽度设置scrollX
            that.tableObj.scroll.x = 180 * that.tableObj.columns.length;
          });
        } else {
          this.$error({
            title: '提示',
            content: res.result,
          });
        }
      };
      let errorFunc = (res) => {
        this.tableObj.tableLoading = false;
        this.$error({
          title: '提示',
          content: res.result,
        });
      };

      //搜索地址
      let url = INVOICE_QUERYINVOHISLIST;
      ajax.fetch(url, requestParam, successFunc, errorFunc)

    },
    resetEvt() {
      this.condition = {
        contrantId: undefined,
        startDate: undefined,
        endDate: undefined,
      }
      this.pageData.invoiceDate = [];
    },
    invoiceUrlOpen(rowData){
      window.open(rowData.invoiceUrl)
    },
    redApply(rowData){
      this.$confirm({
        title: '温馨提示',
        content: '确认执行此操作吗？',
        onOk:() => {
          let requestParam = {
            invoiceOrderNo: rowData.invoiceOrderNo
          }
          
          let successFunc = (res) => {
            if (res.code === "0000") {
              this.$message.success(res.result);
              this.search()
            } else {
              this.$error({
                title: '提示',
                content: res.result,
              });
            }
          };
          let errorFunc = (res) => {
            this.$error({
              title: '提示',
              content: res.result,
            });
          };

          //搜索地址
          let url = INVOICE_REDAPPLY;
          ajax.fetch(url, requestParam, successFunc, errorFunc)
        }
      });
    },
    invoice(rowData){
      this.$confirm({
        title: '温馨提示',
        content: '确认执行此操作吗？',
        onOk:() => {
          let requestParam = {
            invoiceOrderNo: rowData.invoiceOrderNo
          }
          
          let successFunc = (res) => {
            if (res.code === "0000") {
              this.modal.visible = true
              this.modal.list = res.data
              this.modal.result = res.result
            } else {
              this.$error({
                title: '提示',
                content: res.result,
              });
            }
          };
          let errorFunc = (res) => {
            this.$error({
              title: '提示',
              content: res.result,
            });
          };

          //搜索地址
          let url = INVOICE_INVOICE;
          ajax.fetch(url, requestParam, successFunc, errorFunc)
        }
      });
    },
    modalCancel(){
      this.search()
    },
  }
}
</script>

<style scoped>
.space-margin-bottom{
  margin-bottom: 10px;
}
</style>